export const DEFAULT_SITE = 'datadoghq.eu';
